module.exports = __webpack_public_path__ + "img/1544012008.40119248.jpg";